import { AlertDialog as RadixAlertDialog } from "radix-ui";

import { DataConnector } from "@/api/data-connectors";
import { Button } from "@/design-system/components/Button/Button";

interface Props {
  dataConnector: DataConnector | undefined;
  onConfirm: () => void;
  onCancel: () => void;
  isPending?: boolean;
}

export function DataConnectorDisableConfirmation({
  dataConnector,
  onConfirm,
  onCancel,
  isPending,
}: Props) {
  const open = !!dataConnector;
  const description = dataConnector?.name
    ? `"${dataConnector.name}" will stop receiving data until it's re-enabled. Records already ingested are preserved.`
    : "This data connector will stop receiving data until it's re-enabled. Records already ingested are preserved.";

  return (
    <RadixAlertDialog.Root
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onCancel();
      }}
    >
      <RadixAlertDialog.Portal>
        <RadixAlertDialog.Overlay className="z-overlay fixed inset-0 bg-gray-900 opacity-80" />
        <RadixAlertDialog.Content className="z-overlay bg-surface-default fixed top-1/2 left-1/2 flex max-w-2xl -translate-1/2 flex-col gap-3 rounded-md p-4">
          <RadixAlertDialog.Title className="font-bold">
            Disable data connector?
          </RadixAlertDialog.Title>
          <RadixAlertDialog.Description>
            {description}
          </RadixAlertDialog.Description>
          <div className="mt-4 flex justify-end gap-2">
            <RadixAlertDialog.Cancel asChild>
              <Button variant="outline" disabled={isPending}>
                Cancel
              </Button>
            </RadixAlertDialog.Cancel>
            <Button onClick={onConfirm} disabled={isPending}>
              Disable
            </Button>
          </div>
        </RadixAlertDialog.Content>
      </RadixAlertDialog.Portal>
    </RadixAlertDialog.Root>
  );
}
